import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Header from './layout/Header';
import Translate from './layout/Translate';
import {Track, TrackedDiv, TrackDocument} from 'react-track';
import * as userActions from '../actions/user';
import * as toursActions from '../actions/tours';
import {tween, combine} from 'react-imation';
import {rotate} from 'react-imation/tween-value-factories';
import TourPreview from './tours/Preview';
import PromoParallax from './wiget/PromoParallax';
import ReactCursorPosition from 'react-cursor-position';
import Helmet from "react-helmet";
import {
	topTop,
	topBottom,
	centerCenter,
	topCenter,
	bottomBottom,
	bottomTop,
	getDocumentRect,
	getDocumentElement,
	calculateScrollY
} from 'react-track/tracking-formulas';
import ReactPlayer from 'react-player'

var Scroll = require('react-scroll');


var ScrollLink = Scroll.Link;
var DirectLink = Scroll.DirectLink;
var ScrollElement = Scroll.Element;
var ScrollEvents = Scroll.Events;
var scroll = Scroll.animateScroll;
var scrollSpy = Scroll.scrollSpy;
var scroller = Scroll.scroller;

class PromoHB extends Component {
	componentDidUpdate(_prevProps, _prevState) {

	}

	componentWillMount () {
		this.props.userActions.selectDiscount(25);
		this.props.toursActions.fetchTours();

		this.screenHeight = 1000;
		this.lastScrollPos = 0;
		this.direction = 1;

		this.speedConfig = [
			700, 1000, 700, 1000, 700, 1000, 700
		];


		this.discountConfig = {
			25: [92,
				180,
				207
			],
			15: [57,
				98,
				133,
				134,
				142,
				182,
				184,
				185,
				202,
				205,
				208,
				209
			],
			10: [9,
				84,
				88,
				91,
				99,
				108,
				122,
				206,
				123,
				125,
				126,
				128,
				129,
				138,
				143,
				164,
				176,
				177,
				186,
				188,
				189,
				193,
				194,
				195,
				197,
				206
			]
		}

	}




	scrollToDiscount(e) {
		scroller.scrollTo('section1', {
			duration: 500,
			delay: 0,
			smooth: true
		});
	}


	selectDiscount(discount) {
		this.props.userActions.selectDiscount(discount);
	}

  render() {

	  let { user, tours } = this.props;

	  let tooltips = {
		  en: {
			  25: <div className="promo__tooltip promo__tooltip_active">
				  <span style={{fontSize: '32px',lineHeight: '27px'}}>MAX</span>
				  <span style={{fontSize: '35px',lineHeight: '29px'}}>25%</span>
				  <span style={{fontSize: '15px'}}>AND FREE</span>
				  <span style={{fontSize: '32px',lineHeight: '23px'}}>VISA</span>
			  </div>,
			  15:
				  <div className="promo__tooltip">
					  <span style={{fontSize: '14px',lineHeight: '16px'}}>DISCOUNT</span>
					  <span style={{fontSize: '36px',lineHeight: '31px'}}>15%</span>
				  </div>,
			  10:
				  <div className="promo__tooltip">
					  <span style={{fontSize: '14px',lineHeight: '16px'}}>DISCOUNT</span>
					  <span style={{fontSize: '36px',lineHeight: '31px'}}>10%</span>
				  </div>
		  },
		  fr: {
			  25: <div className="promo__tooltip promo__tooltip_active">
				  <span style={{fontSize: '31px',lineHeight: '27px'}}>max.</span>
				  <span style={{fontSize: '12px',lineHeight: '11px', position:'relative', left: '-2px'}}>réduction</span>
				  <span style={{fontSize: '35px',lineHeight: '29px'}}>25%</span>
				  <span style={{fontSize: '26px',lineHeight: '23px'}}>+visa</span>
				  <span style={{fontSize: '18px',lineHeight: '20px'}}>gratuit</span>
			  </div>,
			  15:
				  <div className="promo__tooltip">
					  <span style={{fontSize: '13px',lineHeight: '14px'}}>réduction</span>
					  <span style={{fontSize: '36px',lineHeight: '31px'}}>15%</span>
				  </div>,
			  10:
				  <div className="promo__tooltip">
					  <span style={{fontSize: '13px',lineHeight: '14px'}}>réduction</span>
					  <span style={{fontSize: '36px',lineHeight: '31px'}}>10%</span>
				  </div>
		  },
		  ru: {
			  25: <div className="promo__tooltip promo__tooltip_active">
				  <span style={{fontSize: '24px',lineHeight: '20px'}}>макс.</span>
				  <span style={{fontSize: '18px',lineHeight: '23px'}}>скидка</span>
				  <span style={{fontSize: '36px',lineHeight: '27px'}}>25%</span>
			  </div>,
			  15:
				  <div className="promo__tooltip">
					  <span style={{fontSize: '20px',lineHeight: '21px', textTransform: 'none'}}>скидка</span>
					  <span style={{fontSize: '36px',lineHeight: '31px', textTransform: 'none'}}>15%</span>
				  </div>,
			  10:
				  <div className="promo__tooltip">
					  <span style={{fontSize: '20px',lineHeight: '21px', textTransform: 'none'}}>скидка</span>
					  <span style={{fontSize: '36px',lineHeight: '31px', textTransform: 'none'}}>10%</span>
				  </div>
		  }
	  };


    return (
		<div style={{position: 'relative', zIndex: 100}}>

			<Helmet
				title={(user.seo.title)?user.seo.title:"BaikalNature 10 Years"}
			/>
										<section className="promo_ten">

											<TrackDocument formulas={[getDocumentElement, getDocumentRect, calculateScrollY,
								   topTop, topBottom, topCenter, centerCenter, bottomBottom,
								   bottomTop]}>
												{(documentElement, documentRect, scrollY, topTop,
												  topBottom, topCenter, centerCenter, bottomBottom, bottomTop) =>
													<div className="" >


														<Track component="section" formulas={[topTop, topBottom, centerCenter, bottomTop]} name="">
															{(SECTION, posTopTop, posTopBottom, posCenterCenter, posBottomTop) =>
											<SECTION className="promo__screen">

												<ReactCursorPosition  {...{
													className: ''
												}}>
													<PromoParallax />
												<ScrollElement  name="section0">
													<Header  />
													<div className={"promo__ten promo__ten_" + user.lang}>
														
													</div>
													<div className={"promo__discount promo__discount_" +user.lang } onClick={this.scrollToDiscount.bind(this)}
														 style={tween(scrollY, [
																  [  posBottomTop/2, { opacity: 1 } ],
																  [ posBottomTop, { opacity: 0 } ]
															  ])}
													></div>
												</ScrollElement>
												</ReactCursorPosition>
											</SECTION>
															}
														</Track>

													</div>
												}
											</TrackDocument>

											<div className="promo__screen">
												<ScrollElement  name="section1">

													<div className="promo__text">
														<Translate slug="promo__text" />
													</div>

												<div className="promo__buttons">




													<a className={"promo__button " + (user.discount==25?'promo__button_active':'')} onClick={this.selectDiscount.bind(this, 25)}>
														{tooltips[user.lang][25]}
													</a>
													<a className={"promo__button " + (user.discount==15?'promo__button_active':'')} onClick={this.selectDiscount.bind(this, 15)}>
														{tooltips[user.lang][15]}
													</a>
													<a className={"promo__button " + (user.discount==10?'promo__button_active':'')} onClick={this.selectDiscount.bind(this, 10)}>
														{tooltips[user.lang][10]}
													</a>
												</div>
												<div>

													{tours.map((tour, i) =>
													<div>
														{user.discount && this.discountConfig[user.discount].indexOf(tour.id) != -1 &&
															<TourPreview key={'tour' + tour.id} showPhotos={true} isPromo={true} discount={user.discount} lang={this.props.lang} tour={tour} selectTour={this.props.toursActions.selectTour} />
														}
													</div>
													)}

												</div>
												</ScrollElement>
											</div>
											<div className="overview__registration" style={{margin: '67px 0 40px'}}>
												<Translate slug="main__registration" />
											</div>
										</section>
		</div>
  
    );
  }
}




PromoHB.need = [
	{ action: toursActions.fetchTours }
];


function mapStateToProps(state) {
	return {
		user : state.user,
		tours: state.tours.list
	};
}


function mapDispatchToProps(dispatch) {
	return {
		userActions: bindActionCreators(userActions, dispatch),
		toursActions: bindActionCreators(toursActions, dispatch)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(PromoHB);



// WEBPACK FOOTER //
// ./src/common/components/PromoHB.js